export const prepareText = (val, cols, rows) => {
  const lines = val.split('\n');
  let space;
  for (var i = 0; i < lines.length; i++) {
    if (lines[i].length <= cols) {
      continue;
    }
    var j = 0;
    space = cols;
    while (j++ <= cols) {
      if (lines[i].charAt(j) === ' ') {
        space = j;
      }
    }
    lines[i + 1] = lines[i].substring(space) + (lines[i + 1] || '');
    lines[i] = lines[i].substring(0, space);
  }
  return lines.slice(0, rows).join('\n');
};
